import { requestTool } from "../../tools";

export const GeometryMenuRequest = {

    async lockStatus(request) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/GeometryMenuLock/CheckLockStatus";

        return requestTool.postRequest(_url, request).then(res => {
            if (res) {
                return res;
            }
        })

    },

    async lockEntity(request) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/GeometryMenuLock/LockEntity";

        return requestTool.postRequest(_url, request).then(res => {
            if (res) {
                return res;
            }
        })
    },
    async deleteLock(request) {
        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/GeometryMenuLock/DeleteLock";

        return requestTool.postRequest(_url, request).then(res => {
            if (res) {
                return res;
            }
        })
    },
    async extendTime(request) {
        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/GeometryMenuLock/ExtendExpires";

        return requestTool.postRequest(_url, request).then(res => {
            if (res) {
                return res;
            }
        })
    }
}